"use client"

import { t } from "@/languages/i18n"
import { Form, Input, InputNumber } from "antd"
import React from "react"
import CategoriesRelation from "./CategoriesRelation"

export interface VideoFormValues {
  title: string
  youtubeUrl: string
  order?: number
  categories?: number[]
}

interface VideoFormFieldsProps {
  form: any
  isEditMode: boolean
}

const VideoFormFields: React.FC<VideoFormFieldsProps> = ({ form, isEditMode }) => {
  return (
    <>
      <Form.Item
        className="w-full"
        style={{ marginBottom: 20, width: "100%" }}
        name="title"
        label={<span className="text-base font-medium">{t("Title")}*</span>}
        rules={[
          {
            required: true,
            message: t("Tiêu đề là bắt buộc"),
          },
        ]}
      >
        <Input style={{ width: "100%" }} />
      </Form.Item>

      <Form.Item
        className="w-full"
        style={{ marginBottom: 20, width: "100%" }}
        name="youtubeUrl"
        label={<span className="text-base font-medium">{t("Youtube URL")}</span>}
      >
        <Input style={{ width: "100%" }} />
      </Form.Item>

      <Form.Item
        className="w-full"
        style={{ marginBottom: 20 }}
        name="categories"
        label={
          <Form.Item shouldUpdate noStyle>
            {() => (
              <span className="text-base font-medium">
                {t("Categories")} ({form.getFieldValue("categories")?.length || 0})
              </span>
            )}
          </Form.Item>
        }
        getValueFromEvent={value => value}
        getValueProps={value => ({ value: value || [] })}
      >
        <CategoriesRelation />
      </Form.Item>

      <Form.Item
        className="w-full"
        style={{ marginBottom: 20 }}
        name="order"
        label={<span className="text-base font-medium">{t("Order")}</span>}
        rules={[
          {
            type: "number",
            min: 1,
            message: t("min. 1"),
          },
        ]}
        getValueProps={value => ({ value: value ?? undefined })}
        normalize={value => (value === null || value === undefined ? undefined : Number(value))}
      >
        <InputNumber min={1} style={{ width: "100%" }} />
      </Form.Item>
    </>
  )
}

export default VideoFormFields
